import { Grid } from "@mui/material";
import { ParentSize } from "@visx/responsive";
import { Top5Words } from "src/components/chart/charts";
import { DashboardDto } from "src/types/main-dashboards/types";
import {
  AreaChartByDate,
  AreaChartByKeyword,
  CardDataType,
  PieChartDataType,
  Top5WordsChartPropsType,
  Top5WordsDataType,
  WordCloudChartType,
} from "src/types/types";
import DashboardAreaChart from "../dashboard-area-chart";
import DashboardWordCloud from "../dashboard-word-cloud";
import DashboardAreaChartByKeyword from "../dashboard-area-chart-by-keyword/dashboard-area-chart-by-keyword";

type GeneralAnalysisType = {
  cards: CardDataType[];
  insightsDetails?: Record<string, any>[];
  top5Words: Top5WordsDataType;
  wordCloudChart: WordCloudChartType;
  pieChart: PieChartDataType;
  areaChartByDate: AreaChartByDate;
  areaChartByKeyword?: AreaChartByKeyword; // Only in main
};

export const STATISTICS = (platformData: DashboardDto<GeneralAnalysisType>) =>
  [
    {
      title: platformData?.analysis.areaChartByDate.title,
      data: platformData?.analysis.areaChartByDate,
      component: platformData?.analysis.areaChartByDate && (
        <DashboardAreaChart data={platformData?.analysis.areaChartByDate} />
      ),
    },
    {
      title: platformData?.analysis.top5Words.title,
      data: platformData?.analysis.top5Words,
      component: platformData?.analysis.top5Words && (
        <Top5Words
          title={platformData?.analysis.top5Words.title}
          content={platformData?.analysis.top5Words.content}
        />
      ),
    },
    {
      title: platformData?.analysis.areaChartByKeyword?.title,
      data: platformData?.analysis.areaChartByKeyword,
      component: platformData?.analysis.areaChartByKeyword && (
        <DashboardAreaChartByKeyword data={platformData?.analysis.areaChartByKeyword} />
      ),
    },
    {
      title: platformData?.analysis.wordCloudChart?.title,
      data: platformData?.analysis.wordCloudChart,
      component: platformData?.analysis.wordCloudChart && (
        <ParentSize>
          {({ width }) => (
            <DashboardWordCloud
              data={platformData?.analysis?.wordCloudChart?.content!}
              width={width}
              height={365}
            />
          )}
        </ParentSize>
      ),
    },
  ].filter((s) => s.component);
